const action = name => `SHARING.${name}`;

export const SET_SHARING_SETTINGS_RESPONSE = action('SET_SHARING_SETTINGS_RESPONSE');
export const BEGIN_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST = action(
  'BEGIN_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST',
);
export const END_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST = action(
  'END_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST',
);
export const SET_ADVISERS_IN_THE_SAME_ORGANIZATION_RESPONSE = action(
  'SET_ADVISERS_IN_THE_SAME_ORGANIZATION_RESPONSE',
);
export const SET_API_ERRORS = action('SET_API_ERRORS');

export const setSharingSettingsResponse = (canTransferOwnership, clientRelationships) => ({
  type: SET_SHARING_SETTINGS_RESPONSE,
  canTransferOwnership,
  clientRelationships,
});
export const beginAdvisersInTheSameOrganizationRequest = () => ({
  type: BEGIN_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST,
});
export const endAdvisersInTheSameOrganizationRequest = () => ({
  type: END_ADVISERS_IN_THE_SAME_ORGANIZATION_REQUEST,
});
export const setAPIErrors = apiErrors => ({ type: SET_API_ERRORS, apiErrors });
